import httpClient from "httpClient"

const get = (request) => {
    
    const pathname = '/profissionais'
            
    return httpClient.post(pathname, request)    
}

const profissionais = {
    get,
}

export default profissionais

